/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useLocation, useParams, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as common from './__redux/commonRedux';
import '../../../assets/css/header.css';
import { ReactComponent as BarCode } from '../../../assets/icons/ic_barcode.svg';
import {
	detectMobile,
	detectMobile2
} from '../../../utilities/helpers/MobileHelper';
import { useDictionary } from '../../../utilities/hooks/UseDictionary';
import ProfileWidget from './ProfileWidget';
import PropTypes from 'prop-types';
import BarCodeMenu from '../components/QrCode/BarCodeMenu';
import { useUser } from '../../../utilities/hooks/UseUser';
import { useAccount } from '../../../utilities/hooks/UseAccount';

const Header = (props) => {
	// const dictionary = useDictionary();
	const location = useLocation();
	const { id } = useParams();
	const [addButton, setAddButton] = useState(null);
	const [showFilterDialog, setShowFilterDialog] = useState(false);
	let isMobile = detectMobile();
	const userTypeId = props?.user?.user_type?.id;
	const adminPaths = ['/hotels', '/providers', '/tests'];
	const user = useUser();
	const account = useAccount();
	const isVerified = account?.verification_status?.value === '3';

	const toggleBurger = (event) => {
		event.stopPropagation();

		if (detectMobile2()) {
			if (props.burger) {
				props.closeBurger();
			} else {
				props.openBurger();
			}
		} else {
			props.expand();
		}
	};

	const showFiterlDialogWithMode = () => {
		setShowFilterDialog(true);
	};

	useEffect(() => {}, [location]);

	return (
		<div className="header-wrapper">
			<div className="header-search-container">
				{props.collapsed || detectMobile2() ? (
					<div
						className="header-icon header-icon-list"
						onClick={(e) => {
							toggleBurger(e);
						}}
					/>
				) : null}
				{/*<div className='header-divider'/>
                <div className='header-search-icon'/>
                <input placeholder={dictionary.header_search} className='header-search-input' type='text'/>*/}
			</div>
			<div className="header-icons-container">
				{
					(user.user_type.id == 2 && isVerified) && (
						<div className='header-icon-wraper' onClick={showFiterlDialogWithMode}>
							<BarCode />
						</div>
					)
				}
                {/* <div className='header-icon header-icon-message'/>
                <div className='header-icon header-icon-notification'/> */}
				{window.innerWidth > 986 ? <ProfileWidget /> : null}
			</div>
			{
                showFilterDialog? (
					<BarCodeMenu setShowFilterDialog={setShowFilterDialog}/>
                ) : null
			}
		</div>
	);
};

Header.propTypes = {
	collapsed: PropTypes.bool,
	expand: PropTypes.func,
	burger: PropTypes.bool,
	openBurger: PropTypes.func,
	closeBurger: PropTypes.func,
	user: PropTypes.object
};

export default connect(common.states, common.actions)(withRouter(Header));
